import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { IconButton } from '@perch-labs/shrike';

export const CloseButton = styled(IconButton)`
  position: absolute;
  display: block;
  top: 36px;
  right: 30px;
  border: ${props => `1px solid ${props.theme.colors.background.tertiary}`};
`;

export const ButtonWrapper = styled.div`
  position: relative;
`;

export const StyledSVG = styled(SVG).attrs({
  width: '70px',
  height: '70px',
  'aria-hidden': true,
})`
  margin-top: 16px;
  margin-bottom: 42px;
`;
